// extracted by mini-css-extract-plugin
module.exports = {"frame":"KnowledgeBaseTab_frame__gtlAp","Bnt":"KnowledgeBaseTab_Bnt__QEi1x"};